import React from 'react';

import { PropertyType } from '@ha/algolia';

import { useIntl } from 'ha/i18n';
import { ListingCardModel } from 'ha/models/Listing/types';

import { ListingCardDetailsAttribute } from './ListingCardDetailsAttributes';

interface ListingCardDetailsAttributesPropertyPlacesProps {
  listing: ListingCardModel;
}

export const shouldShowListingCardDetailsAttributesPlaces = (
  listing: ListingCardModel,
) =>
  listing.space.propertyType === PropertyType.apartment ||
  listing.space.propertyType === PropertyType.house ||
  listing.space.propertyType === PropertyType.building ||
  listing.space.propertyType === PropertyType.studio ||
  listing.space.propertyType === PropertyType.sharedRoom ||
  listing.space.propertyType === PropertyType.privateRoom;

export const ListingCardDetailsAttributesPlaces = React.memo(
  ({ listing }: ListingCardDetailsAttributesPropertyPlacesProps) => {
    const { T } = useIntl();

    const label = React.useMemo(() => {
      if (
        listing.space.propertyType === PropertyType.apartment ||
        listing.space.propertyType === PropertyType.house ||
        listing.space.propertyType === PropertyType.building
      ) {
        return listing.space.bedroomCount === '1'
          ? T('1 Bedroom')
          : T('%s Bedrooms', listing.space.bedroomCount);
      }

      if (
        listing.space.propertyType === PropertyType.studio ||
        listing.space.propertyType === PropertyType.sharedRoom
      ) {
        return listing.space.freePlaces === 1
          ? T('listing_card.space_1_person')
          : T('listing_card.space_%d_people', listing.space.freePlaces);
      }

      if (listing.space.propertyType === PropertyType.privateRoom) {
        return listing.space.currentOccupancy === 1
          ? T('ldp.1_housemate')
          : T('ldp.%d_housemates', listing.space.currentOccupancy);
      }

      return null;
    }, [
      listing.space.propertyType,
      listing.space.bedroomCount,
      listing.space.freePlaces,
      listing.space.currentOccupancy,
      T,
    ]);

    if (!label) return null;

    return (
      <ListingCardDetailsAttribute
        slots={{ icon: null, label }}
        data-test-locator="ListingCard/AttributesPlaces"
      />
    );
  },
);
